import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  getEntityActivitiesQueryKey,
  listEntityActivities,
  type ActivityEntity,
} from '../api/activities.client.js';

/** `entityId === null` — история не запрашивается (дровер закрыт). */
export function useEntityActivities(entity: ActivityEntity, entityId: string | null) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getEntityActivitiesQueryKey(workspaceId, entity, entityId ?? 'none'),
    queryFn: () => listEntityActivities(entity, entityId as string),
    enabled: scope !== null && entityId !== null,
  });
}
